var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSendArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2993 8.99928H3.69267C3.69267 8.77012 3.64517 8.54095 3.55101 8.32595L1.57017 3.84428C0.93684 2.41095 2.45184 0.975951 3.84851 1.68512L15.3327 7.51345C16.5493 8.13012 16.5493 9.86845 15.3327 10.4851L3.84934 16.3135C2.45184 17.0226 0.93684 15.5868 1.57017 14.1543L3.54934 9.67262C3.64288 9.46047 3.69113 9.23114 3.69101 8.99928",
    stroke: "#FFFEFF",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendArrow);
export default __webpack_public_path__ + "static/media/sendArrow.1a9310c169a6afc5501da0dcbe31082f.svg";
export { ForwardRef as ReactComponent };